import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';

const CounterSection = ({ className }) => {
  const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.3
    });

  const { t } = useTranslation();
  // Counter data
  const counters = t('sections.counterSecOne.counters', { returnObjects: true }) || [
    {
      id: 1,
      title: 'Projects Completed',
      number: '5000',
      suffix: '+',
      themeColor: '#069845',
    },
    {
      id: 2,
      title: 'Client Retention Rate',
      number: '95',
      suffix: '%',
      themeColor: '#F0A230',
    },
    {
      id: 3,
      title: 'Customers Globally',
      number: '150',
      suffix: 'k+',
      themeColor: '#E0009B',
    },
    {
      id: 4,
      title: 'Years Of Experience',
      number: '25',
      suffix: '+',
      themeColor: '#8F54FF',
    },
  ];

  return (
    <div className={className}>
      <div className="container">
          <div className="title-area text-center">
          <span className="sub-title" data-cue="slideInUp">
            {t('sections.counterSecOne.sub_title','Our Achievement')}
          </span>
          <h2 className="sec-title" data-cue="slideInUp" data-delay="100">
            {t('sections.counterSecOne.title','Discover What Defines Us')}
          </h2>
        </div>
        <div className="row gy-4">
          {counters.map((counter) => (
            <div className="col-xl-3 col-md-6" key={counter.id}>
              <div className="counter-card" data-cue="slideInUp">
                <div className="media-body">
                  <h2 className="box-number">
                    <span ref={ref}>
                        {inView && (
                            <CountUp
                                start={0}
                                end={counter.number}
                                duration={2.5}
                                separator=","
                                suffix={counter.suffix}
                                className="count-up-text"
                            />
                        )}
                    </span>
                  </h2>
                  <span 
                    className="box-text" 
                    data-theme-color={counter.themeColor}
                  >
                    {counter.title}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CounterSection;